import axios from 'axios';
import headers from "../Header";

let url = '/sdi/wilayah'
class MasterWilayahAllService {
    getProvinsi() {
        return axios.get(url + '/provinsi', {
            headers: headers(),
        })
    }

    getKabupatenKotaByProvinsi(id) {
        return axios.get(url + '/kabupaten-kota?kode_prov=' + id, {
            headers: headers(),
        })
    }

}

export default new MasterWilayahAllService();